<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <!-- <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddFact" class="ml-auto">
                    <span class="color-white">
                        add fact
                    </span>
                </el-button>
            </div> -->
            <el-card class="box-card">
                <el-table :data="allFacts" style="width: 100%">
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="title En" align="right">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                   
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" align="right" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="description Ar"  >
                        <template #default="scope">
                           <div class="rtl text-right">
                               {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="fact value"  prop="value" align="right"/>
                  
                    
                    <el-table-column label="Operations" width="100 ">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit fact"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditFact(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                    
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedAllFacts(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.home?.facts?.list || []
        },
    },
    data(){
        return{
            allFacts:[],
            isAddFact:false,
           
        }
    },
    mounted(){
        
        if (!this.cachedAllFacts.length){
            this.getAllFacts();
        }else{
           
            this.allFacts = this.cachedAllFacts;
        }
    },
    
    methods:{
       
        async getAllFacts(){
            
            const response = await this.$store.dispatch('getAllFacts');
          
            this.allFacts = response.data;
            
            
        },
    
        async changeFactStatus(factData){
            
            let dataToSend = {
                status: factData.status,
                id:factData.id
            }
            const response = await this.$store.dispatch('changeFactStatus',dataToSend);
            if (response.data.status == 1){
                this.getAllFacts();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }else{
                const currentFact = this.allFacts.find(fact => fact.id == factData.id )
                currentFact.status = !currentFact.status
            }
            
        },
       
        async handleAddFact(){
            this.$router.push({
                name:'manage-fact',
            })
           
        },
        async handleEditFact(fact){
            await this.$store.dispatch('storeCurrentFactToView',fact)
            this.$router.push({
                name:'manage-fact',
                params:{
                    id:fact.id
                }
            })
        }
    }
}
</script>